// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar___2lL2S"};